import { Component, computed, Inject, OnInit, signal } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleChange, MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LoadSchedulePopupInput } from '../../../../interfaces/feedstocklistmodel';
import { FeedstockService } from '../../../../services/feedstockservice';
import { LookUpService } from '../../../../services/lookupservice';
import { DialogData, PickUpLocInput } from '../../../../interfaces/streamrecurringLoad';
import { Regions } from '../../../../interfaces/regions';
import { StreamsList } from '../../../../interfaces/streamsmodel';
import { SaveStreamPickupLocationRequest } from '../../../../interfaces/generatorsmodel';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-addedit-pickuplocation',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule
  ],
  templateUrl: './addedit-pickuplocation.component.html',
  styleUrl: './addedit-pickuplocation.component.scss'
})
export class AddeditPickuplocationComponent implements OnInit {
  
  customerID = signal<number | null>(null);
  streamId = signal<number | null>(null);
  
  pickupLocationName = signal<string>('');
  sameAsCustomerAddress = signal<boolean>(false);
  
  addressLine1 = signal<string | null>(null);
  addressLine2 = signal<string | null>(null);
  city = signal<string | null>(null);
  state = signal<string | null>(null);
  zipCode = signal<string | null>(null);
  municipality = signal<string | null>(null);
  
  marketID = signal<number | null>(-1);
  marketOptions = signal<Regions[]>([]);
  isFormReady = signal<boolean>(false);
  showSaveButton = signal<boolean>(true);
  submitted = signal<boolean>(false);

  getPayload = computed<SaveStreamPickupLocationRequest>(() => {
    const isSameAddress = this.sameAsCustomerAddress();
    return {
      customerID: this.customerID() || 0,
      streamId: this.streamId() || 0,
      pickupLocationName: this.pickupLocationName(),
      sameAsCustomerAddress: isSameAddress,
      addressLine1: isSameAddress ? null : this.addressLine1(),
      addressLine2: isSameAddress ? null : this.addressLine2(),
      city: isSameAddress ? null : this.city(),
      state: isSameAddress ? null : this.state(),
      zipCode: isSameAddress ? null : this.zipCode(),
      municipality: isSameAddress ? null : this.municipality(),      
      market: this.marketID()
      //ShowPickupLocationSaveButton: this.showSaveButton()
    };
  });

  constructor(
    private lookUp: LookUpService,
    private feedstockService: FeedstockService,
    public dialogRef: MatDialogRef<AddeditPickuplocationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PickUpLocInput) { 
      
      console.log("incomingpickuplocation data", data);

    }

  ngOnInit() {
    this.customerID.set(this.data.genid);
    this.streamId.set(this.data.streamid);

    this.lookUp.getMarketsList('-1').subscribe({
      next: (markets) => {
        console.log('Markets loaded for Pickup Location:', markets);
        this.marketOptions.set(markets);
        if (this.data.inputData) {
            this.loadForm(this.data.inputData);
        }
        this.isFormReady.set(true);
      }
    });
  }

  loadForm(load: StreamsList) {
    this.pickupLocationName.set(load.pickupLocationName || '');
    this.sameAsCustomerAddress.set(load.sameAsCustomerAddress || false);
    if (!load.sameAsCustomerAddress) {
      this.addressLine1.set(load.addressLine1 || '');
      this.addressLine2.set(load.addressLine2 || '');
      this.city.set(load.city || '');
      this.state.set(load.state || '');
      this.zipCode.set(load.zipCode || '');
      this.municipality.set(load.municipality || '');
    } else {
      this.clearAddressSignals();
    }
    this.marketID.set(load.market || -1);
    //this.showSaveButton.set(load.showPickupLocationSaveButton || false);
  }

  clearAddressSignals(): void {
    this.addressLine1.set(null);
    this.addressLine2.set(null);
    this.city.set(null);
    this.state.set(null);
    this.zipCode.set(null);
    this.municipality.set(null);
  }
  
  savePickupLocation(): void {
    this.submitted.set(true);
    if (!this.pickupLocationName()) {
        return;
    }

    const payload = this.getPayload();

    this.feedstockService.savePickUpLoc(payload).subscribe({
        next: (response) => {
          console.log('Save successful:', response);
          this.dialogRef?.close(true);
        }
    });
  }
  
  onClose(): void {
    this.dialogRef?.close({ saved: false });
  }

  onAddressCheck(event: MatSlideToggleChange): void {
    this.sameAsCustomerAddress.set(event.checked);
    if (event.checked) {
      this.clearAddressSignals();
    }
  }

}
